/**
 * Minimal geo-debug utilities. No UI dependencies — safe for AuthService and boot.
 * Use ?geo_debug query param (no value) to enable geo-debug mode.
 */

const GEO_DEBUG_PARAM = 'geo_debug'

/**
 * Returns the current URL with geo_debug param removed. Use for Launch app navigation
 * to preserve pathname, other query params, and hash.
 */
export function buildLaunchUrlWithoutGeoDebug(): string {
	if (typeof window === 'undefined') return '/'
	const { pathname, search, hash } = window.location
	const params = new URLSearchParams(search)
	params.delete(GEO_DEBUG_PARAM)
	const searchStr = params.toString()
	const query = searchStr ? `?${searchStr}` : ''
	return `${pathname}${query}${hash}`
}

export function isGeoDebugMode(): boolean {
	if (typeof window === 'undefined') return false
	return new URLSearchParams(window.location.search).has(GEO_DEBUG_PARAM)
}
